import React from 'react';

import Loader from 'crehana-ui/Loader';
import Text from 'crehana-ui/Text';

import { useTranslation } from 'Shared/Hooks/useTranslation';

import { usePricesContext } from 'Jsx/CourseDetail/Context/Prices';

import Question from './Question';
import locales from '../../../i18n/localeEs';

const translations = locales.es;

type Questions = {
  countryPrefix: string;
};

const Questions: React.FC<Questions> = ({ countryPrefix }) => {
  const { t } = useTranslation();
  const { loading: loadingPrices, prices } = usePricesContext();

  if (loadingPrices || !prices) {
    return (
      <div className="flex justify-center items-center min-h-80 w-full">
        <Loader />
      </div>
    );
  }

  return (
    <section className="flex flex-col">
      <Text className="mb-24" type="h4" as="h2">
        {t('FAQ_TITLE', {
          defaultValue: translations.FAQ_TITLE,
        })}
      </Text>
      <Question
        title={t('FAQ_QUESTION1_TITLE', {
          defaultValue: translations.FAQ_QUESTION1_TITLE,
        })}
        text={t('FAQ_QUESTION1_TEXT', {
          defaultValue: translations.FAQ_QUESTION1_TEXT,
        })}
        textPayTo={t('FAQ_QUESTION1_TEXT_PAY', {
          defaultValue: translations.FAQ_QUESTION2_TEXT_PAY,
        })}
        price={prices.price}
      />
      <Question
        title={t('FAQ_QUESTION2_TITLE', {
          defaultValue: translations.FAQ_QUESTION2_TITLE,
        })}
        text={t('FAQ_QUESTION2_TEXT', {
          defaultValue: translations.FAQ_QUESTION2_TEXT,
        })}
        textPayTo={t('FAQ_QUESTION2_TEXT_PAY', {
          defaultValue: translations.FAQ_QUESTION2_TEXT_PAY,
        })}
        price={prices.price}
      />
      <Question
        title={t('FAQ_QUESTION3_TITLE', {
          defaultValue: translations.FAQ_QUESTION3_TITLE,
        })}
        titlePayTo={t('FAQ_QUESTION3_TITLE_PAY', {
          defaultValue: translations.FAQ_QUESTION3_TEXT_PAY,
        })}
        text={[
          <span key={1}>
            {t('FAQ_QUESTION3_TEXT', {
              defaultValue: translations.FAQ_QUESTION3_TEXT,
            })}
          </span>,
          <a
            aria-label="Catálogo de cursos"
            className="text-primary-main"
            key={2}
            href={
              countryPrefix
                ? `/${countryPrefix}/cursos-online/?all=true`
                : '/cursos-online/?all=true'
            }
            target="_blank"
            rel="noreferrer noopener"
          >
            {' '}
            aquí.
          </a>,
        ]}
        textPayTo={t('FAQ_QUESTION3_TEXT_PAY', {
          defaultValue: translations.FAQ_QUESTION3_TEXT_PAY,
        })}
        price={prices.price}
      />
    </section>
  );
};

export default Questions;
